// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__0y0W4 {
  padding: 2rem;
  max-width: 120rem;
  margin: 0 auto; }

.styles_header__d0Zb4 {
  margin-bottom: 2rem; }

.styles_cardsContainer__\\+yLiQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
  gap: 2rem; }

.styles_card__iQ8a9 {
  padding: 2rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/admin/components/screens/AdminUsersScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,iBAAiB;EACjB,cAAc,EAAA;;AAGlB;EACI,mBAAmB,EAAA;;AAGvB;EACI,aAAa;EACb,2DAA2D;EAC3D,SAAS,EAAA;;AAGb;EACI,aAAa,EAAA","sourcesContent":[".container {\n    padding: 2rem;\n    max-width: 120rem;\n    margin: 0 auto;\n}\n\n.header {\n    margin-bottom: 2rem;\n}\n\n.cardsContainer {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));\n    gap: 2rem;\n}\n\n.card {\n    padding: 2rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__0y0W4`,
	"header": `styles_header__d0Zb4`,
	"cardsContainer": `styles_cardsContainer__+yLiQ`,
	"card": `styles_card__iQ8a9`
};
export default ___CSS_LOADER_EXPORT___;
